import type { WidgetDataMap } from './WidgetDataMap.types';
import type { WidgetType } from './WidgetType.types';

export enum WidgetViewType {
  TOP_STICKY = 'TOP_STICKY',
  NORMAL = 'NORMAL',
  BOTTOM_STICKY = 'BOTTOM_STICKY',
}

interface WidgetBase {
  id: string;
  type: WidgetType;
  viewType?: WidgetViewType;
  rank: number;
}

export interface Widget<T extends WidgetType = WidgetType> extends WidgetBase {
  data: WidgetDataMap[T];
}
